const summonAutopayScript = () => {
  const autopayEnvScript = {
    development: 'https://src.autopay.xyz/widget-embed/1.0.0/widget-embed-1.0.0.js',
    production: 'https://src.apex.autopay.com/widget-embed/1.0.0/widget-embed-1.0.0.js'
  }

  const script = document.createElement('script')
  script.src = autopayEnvScript[process.env.NODE_ENV]
  script.async = true

  document.body.appendChild(script)
}

export default summonAutopayScript
